(function () {
  var script = document.querySelector('script[data-arcos-mail]');
  var companyId = script && script.getAttribute('data-company-id') || 'VNF4nT';
  var listId = script && script.getAttribute('data-list-id') || 'UJqChE';
  var revision = script && script.getAttribute('data-revision') || '2026-04-15';
  var measurementTest = new URLSearchParams(window.location.search).has('ag_test');
  if (!companyId || !listId) return;

  var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId);

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form.ag-email__form');
    if (!form) return;
    var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
    var email = emailInput && emailInput.value && emailInput.value.trim();
    if (!email || form.dataset.klaviyoSubmitted === email) return;
    form.dataset.klaviyoSubmitted = email;
    var locale = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var landingPath = window.location.pathname || '/';
    var sourceInput = form.querySelector('input[name="$source"]');
    var formSource = sourceInput && sourceInput.value || 'desk_relief_reset';
    var message = form.parentElement && form.parentElement.querySelector('.ag-form-message, small');

    function trackSignup() {
      var params = { method: 'Klaviyo', form_source: formSource, locale: locale };
      if (measurementTest) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'sign_up' }, params));
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', 'sign_up', params);
      }
    }

    function setStatus(ok) {
      if (!message) return;
      message.textContent = ok
        ? (locale === 'nl' ? 'Controleer je inbox om je inschrijving te bevestigen.' : locale === 'de' ? 'Prüfen Sie Ihren Posteingang, um die Anmeldung zu bestätigen.' : 'Check your inbox to confirm your subscription.')
        : (locale === 'nl' ? 'Inschrijven lukte niet. Probeer het opnieuw.' : locale === 'de' ? 'Die Anmeldung ist fehlgeschlagen. Bitte erneut versuchen.' : 'Signup failed. Please try again.');
      message.setAttribute('role', 'status');
    }

    if (measurementTest) {
      event.preventDefault();
      trackSignup();
      setStatus(true);
      return;
    }

    // Klaviyo's hosted form endpoint avoids browser CORS failures while preserving
    // the list's double-opt-in policy. The hidden iframe keeps visitors on-page.
    if ((form.action || '').indexOf('manage.kmail-lists.com/ajax/subscriptions/subscribe') !== -1) {
      trackSignup();
      setStatus(true);
      window.setTimeout(function () {
        delete form.dataset.klaviyoSubmitted;
        form.reset();
      }, 1200);
      return;
    }

    event.preventDefault();

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'ArcosGear desk relief reset form',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  source: 'desk_relief_reset',
                  site: 'arcosgear.com',
                  locale: locale,
                  landing_path: landingPath
                },
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    try {
      fetch(endpoint, {
        method: 'POST',
        keepalive: true,
        headers: {
          'accept': 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          'revision': revision
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) throw new Error('Klaviyo subscription failed');
        trackSignup();
        setStatus(true);
        form.reset();
      }).catch(function () {
        delete form.dataset.klaviyoSubmitted;
        setStatus(false);
      });
    } catch (error) {
      delete form.dataset.klaviyoSubmitted;
      setStatus(false);
    }
  }, true);
})();